import { combineReducers } from 'redux';
import { isShowingReducer, loadingReducer } from './action'; 
import { authReducer } from './action';
import { authPageReducer } from './action';
import { cartReducer } from './action';

const rootReducer = combineReducers({
  loading: loadingReducer,
  showAuth: authReducer,
  authPage: authPageReducer,
  isShowing: isShowingReducer,
  cart: cartReducer
});

export default rootReducer;